import { Grid } from "@mui/material";
import { TextEnumAutocomplete } from "components/alove/EnumAutocomplete";
import { AISimulation, AiSimulationModel } from "models/AISimulation";
const MDInput = require("components/MDInput").default;

export const AiSimulationForm = ({aiSimulation, setAiSimulation}: 
    {aiSimulation: AISimulation, setAiSimulation: (aiSimulation: AISimulation) => void}) => {
    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <MDInput
                    fullWidth
                    multiline
                    label="Description"
                    value={aiSimulation.description || ""}
                    onChange={(e) => setAiSimulation({...aiSimulation, description: e.target.value})}
                />
            </Grid>
            <Grid size={6}>
                <TextEnumAutocomplete
                    showValues
                    label="Model"
                    disabled={!!aiSimulation.id}
                    enumName={AiSimulationModel}
                    value={aiSimulation.model || ""}
                    onChange={(value) => setAiSimulation({...aiSimulation, model: value})}
                />
            </Grid>
            <Grid size={6}>
                <MDInput
                    label="Profile ID"
                    value={aiSimulation.profileId}
                    disabled={!!aiSimulation.id}
                    fullWidth
                    onChange={(e) => setAiSimulation({...aiSimulation, profileId: e.target.value})}
                />
            </Grid>
        </Grid>
    )
}